import React from 'react'
import { useLazyQuery, useQuery } from '@apollo/client'
import { InsuranceErrors, InsuranceErrorsVariables } from '../../types'
import { INSURANCE_ERRORS } from './operations'

interface Filters {
  checkedBetween?: Array<string | null>
}

interface Props {
  filter?: Filters
  page?: number
  pageLength?: number
  skip?: boolean
}

interface LazyProps {
  onCompleted?: (data: InsuranceErrors) => void
}

const PAGE_LENGTH = 10

export const useInsuranceErrors = ({
  filter,
  page = 1,
  pageLength = PAGE_LENGTH,
  skip = false,
}: Props = {}) => {
  const { checkedBetween } = filter || {}
  const queryVariables = React.useMemo<InsuranceErrorsVariables>(
    () => ({
      filterData: {
        checkedBetween,
      },
      pagination: {
        from: pageLength * (page - 1),
        length: pageLength,
      },
    }),
    [checkedBetween]
  )
  const insurances = useQuery<InsuranceErrors, InsuranceErrorsVariables>(INSURANCE_ERRORS, {
    variables: queryVariables,
    skip,
  })

  return insurances
}

export const useInsuranceErrorsLazy = ({ onCompleted }: LazyProps) =>
  useLazyQuery<InsuranceErrors, InsuranceErrorsVariables>(INSURANCE_ERRORS, {
    onCompleted,
  })
